import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";





var styles = {
  multiProductsHeading: function multiProductsHeading(_ref) {var columnsAmount = _ref.columnsAmount;return {
      position: 'relative',
      textTransform: 'initial',
      fontSize: '1.6rem',
      width: "".concat(34 * columnsAmount, "rem"),
      borderBottom: "0.2rem solid ".concat(colors.neutral[600]),
      borderLeft: "0.1rem solid ".concat(colors.neutral[600]),
      padding: 0
    };},
  nameWrapper: {
    padding: '1rem',
    paddingLeft: '2.5rem',
    alignItems: 'center',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    display: 'flex',
    '& h2': {
      lineHeight: '5.6rem',
      fontSize: '1.8rem'
    }
  },
  variantTitle: {
    border: 'none',
    justifyContent: 'flex-start',
    marginLeft: '0.5rem',
    '& h2': {
      lineHeight: '4.6rem',
      fontSize: '1.6rem'
    },
    '& svg': {
      width: '4rem',
      height: '4rem'
    },
    paddingRight: '2.5rem'
  },
  productsHeadings: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  bcActionBlock: {
    display: 'flex',
    flexDirection: 'row',
    padding: {
      top: 0,
      right: '3rem',
      bottom: '3rem',
      left: '2.5rem'
    },
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    '& button': {
      marginLeft: '2rem'
    },
    '& > div:first-child': {
      marginBottom: 0
    }
  },
  defaultBcBlock: {
    alignItems: 'center'
  },
  mockButton: {
    height: '4.6rem'
  },
  ratesList: {
    width: '28.5rem',
    marginBottom: '3rem'
  },
  multiVariantsProducts: {
    display: 'flex'
  },
  multiVariantProduct: {
    textTransform: 'initial',
    width: '34rem',
    border: 'none',
    paddingBottom: '1.308rem',
    paddingTop: '0',
    '&:not(:last-child)': {
      borderRight: "0.1rem solid ".concat(colors.neutral[300])
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h2': {
      lineHeight: '2.6rem',
      fontSize: '1.6rem',
      marginTop: '1rem'
    }
  },
  multiVariantHeadingContent: {
    '&:not(:last-child)': {
      borderRight: "0.1rem solid ".concat(colors.neutral[300])
    }
  },
  hiddenTitle: {
    visibility: 'hidden'
  },
  productsInfoList: {
    display: 'flex'
  },
  productName: {
    fontSize: '1.8rem',
    marginLeft: '2.5rem'
  },
  disabledProduct: {
    opacity: '0.6',
    filter: 'grayscale(1)'
  },
  portfolioLogo: {
    padding: '2rem',
    paddingBottom: 0,
    '& img': {
      height: '2.2rem'
    }
  },
  spinnerWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255,255,255,0.8)',
    zIndex: 5
  },
  versionWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  version: {
    fontSize: '1.6rem',
    lineHeight: '4.6rem',
    margin: 0,
    marginRight: '1rem'
  },
  bcTag: {
    margin: 0,
    fontSize: '1.2rem',
    color: colors.neutral.white,
    padding: '0.4rem 1rem',
    borderRadius: '0.4rem',
    fontWeight: 400
  },
  additionalTag: { backgroundColor: colors.purple[600] },
  defaultTag: { backgroundColor: colors.green[600] },
  ratesConfigColor: {
    color: colors.purple[600]
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map